"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_1 = __importDefault(require("@honeybadger-io/js"));
const browser_1 = __importDefault(require("@hyperdx/browser"));
function removeTopItemFromStack(error) {
    let stackTrace = error.stack;
    if (!stackTrace) {
        return '';
    }
    //removing stacktrace lines from this file if we are creating the error here.
    const arr = stackTrace.split('\n');
    arr.splice(1, 2); //remove any lines from this file
    stackTrace = arr.join('\n');
    return stackTrace;
}
function FlashError(msg) {
    const error = new Error(msg);
    error.stack = removeTopItemFromStack(error);
    error.name = 'FlashError';
    return error;
}
function ReCaptchaError(msg) {
    const error = new Error(msg);
    error.name = 'ReCaptchaError';
    error.stack = removeTopItemFromStack(error);
    return error;
}
function BoundaryError(msg) {
    const error = new Error(msg);
    error.name = 'BoundaryError';
    error.stack = removeTopItemFromStack(error);
    return error;
}
const ERROR_TYPE_MAP = {
    flashError: FlashError,
    reCaptchaError: ReCaptchaError,
    boundaryError: BoundaryError,
};
function reportError(errorType, error, exception) {
    browser_1.default.addAction(errorType, error);
    if (exception) {
        js_1.default.notify(exception);
    }
    else {
        const errorClass = ERROR_TYPE_MAP[errorType] || Error;
        js_1.default.notify(errorClass(error.errMsg));
    }
}
exports.default = reportError;
